import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common';
import { classNames } from '@wix/answers-lib';
export var gaugeKey = 'gauge';
export var GaugeColorStates;
(function (GaugeColorStates) {
    GaugeColorStates[GaugeColorStates["EMPTY"] = 0] = "EMPTY";
    GaugeColorStates[GaugeColorStates["MIDDLE_FULL"] = 1] = "MIDDLE_FULL";
    GaugeColorStates[GaugeColorStates["ALMOST_FULL"] = 2] = "ALMOST_FULL";
    GaugeColorStates[GaugeColorStates["FULL"] = 3] = "FULL";
})(GaugeColorStates || (GaugeColorStates = {}));
var Gauge = /** @class */ (function (_super) {
    __extends(Gauge, _super);
    function Gauge() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getLowerBoundary = function () {
            var props = _this.props;
            var value = props.totalValue !== 0 ? (props.actualValue / props.totalValue) * 100 : 0;
            var ranges = _this.props.customRanges || [[0, 39], [40, 59], [60, 79], [80, 100]];
            var matchingRangeIdx = ranges.findIndex(function (range) {
                return (range[0] - value) * (range[1] - value) <= 0;
            });
            return matchingRangeIdx >= 0 && matchingRangeIdx !== ranges.length - 1 ? matchingRangeIdx : GaugeColorStates.FULL;
        };
        return _this;
    }
    Gauge.prototype.render = function () {
        var props = this.props;
        var inverse = !!props.chinaMode;
        var value = props.totalValue !== 0 ? (props.actualValue / props.totalValue) * 100 : 0;
        var lowerBoundary = this.getLowerBoundary();
        var gaugeFillWidth = { width: value + "%" };
        var gaugeClass = (lowerBoundary === GaugeColorStates.EMPTY ? 'empty' :
            (lowerBoundary === GaugeColorStates.MIDDLE_FULL ? 'middle-full' :
                (lowerBoundary === GaugeColorStates.ALMOST_FULL ? 'almost-full' : 'full')));
        return (React.createElement("div", { className: namespacedClassnames(gaugeKey, props.className), "data-lower-boundary": lowerBoundary },
            React.createElement("span", { className: classNames('gauge-fill', gaugeClass, { inverse: inverse }), style: gaugeFillWidth })));
    };
    return Gauge;
}(React.PureComponent));
export { Gauge };
//# sourceMappingURL=index.js.map